import { SizeViewType } from '../../../hooks/useSize'

export default function(size: number, view: SizeViewType = 'forms') {
  return {
    size,
    type: 'Set calendar size',
    view,
  }
}
